export default "__VITE_ASSET__CCeq1Rhs__"